import React, { useEffect, useState } from 'react'
import {
    Space,
    Tabs,
    Card,
    Input,
    Pagination,
    Upload,
    Button,
    message,
    Modal,
    List,
    Avatar,
    Descriptions,
    Divider,
} from 'antd';
import {
    UploadOutlined,
    AuditOutlined,
    InboxOutlined,
} from '@ant-design/icons';
import { sys, hall } from "../../../../service";
import { useSelector } from 'react-redux';

const initial = {
    name: null,
    orderUserName: null,
    type: 1,
    current: 1,
    pageSize: 10,
}

export default function OrderView() {

    const [dataSource, setDataSource] = useState([])
        , [total, setTotal] = useState(0)
        // , [type, setType] = useState(1)                         // 1 查询自己的订单 2 查询服务人是自己的订单
        , [queryParams, setQueryParams] = useState(initial)
        , [openModal, setOpenModal] = useState(false)
        , [orderDetail, setOrderDetail] = useState({})
        , { serverUrl } = useSelector(state => state.siteInfo)

    useEffect(() => {
        fetchData(1)
    }, [queryParams])

    const fetchData = async () => {
        try {
            const { data: { records, total } } = await hall.apiOrder.getList(queryParams)
            setDataSource(records)
            setTotal(total)
        } catch (error) {
            console.log(error);
        }
    }

    const getDetail = async (id) => {
        try {
            const { data } = await hall.apiOrder.getById(id)
            setOrderDetail(data)
            setOpenModal(true)
        } catch (error) {
            console.log(error);
        }
    }

    // 切换tab
    const onTabsChange = (tab) => {
        setQueryParams((value) => ({ ...value, type: tab }))
    }

    // 输入名称查询
    const onSearch = (name) => {
        if (queryParams.type === 1) {
            setQueryParams((value) => ({ ...value, title: name }))
        } else {
            setQueryParams((value) => ({ ...value, title: name }))
        }
    }

    // 分页查询
    const onPaginationChange = (page) => {
        setQueryParams((value) => ({ ...value, current: page }))
    }

    const props = {
        name: 'file',
        beforeUpload: async (file) => {

            // 限制文件大小为20M
            const fileSizeLimit = 20 * 1024 * 1024; // 20MB in bytes
            if (file.size > fileSizeLimit) {
                message.error('文件大小不能超过20MB');
                return false;
            }

            // 上传图片，获取地址
            const { data: { path } } = await sys.uploadFile(file);
            const params = {
                ...orderDetail,
                contractUrl: path,
                state: 2
            }
            await hall.apiOrder.edit(params)
            message.success("上传成功！")
            return false;
        },
    };

    const onEdit = async () => {
        try {
            const params = {
                ...orderDetail,
                state: 1
            }
            await hall.apiOrder.edit(params)
            message.success("取消成功！")
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <Card
            title="订单管理"
            extra={
                <Input.Search placeholder="请输入标题" onSearch={onSearch} enterButton />
            }
        >
            <Tabs
                defaultActiveKey="1"
                onChange={onTabsChange}
                items={[
                    {
                        key: '1',
                        label: '我购买的',
                        children: (
                            <div>
                                <List
                                    pagination={{
                                        position: 'bottom',
                                        align: 'end',
                                        total,
                                        current: queryParams.current,
                                        pageSize: queryParams.pageSize,
                                        showTotal: (total) => `共 ${total} 条`,
                                        onChange: (value) => onPaginationChange(value)
                                    }}
                                    dataSource={dataSource}
                                    renderItem={(item, index) => (
                                        <List.Item
                                            onClick={() => getDetail(item.id)}
                                        >
                                            <List.Item.Meta
                                                // avatar={<Avatar src={`https://api.dicebear.com/7.x/miniavs/svg?seed=${index}`} />}
                                                title={<Space><span>{item.title}</span>-<span>{item.orderUserCompany}</span></Space>}
                                                description={<Space><span>{item.createDate}</span> <span>{item.remark}</span></Space>}
                                            />
                                            <div>{
                                                item.state === 0 ? <Space><span style={{ color: '#666' }}>待确认</span>
                                                    <Button danger type='link' onClick={onEdit}>取消</Button></Space> :
                                                    item.state === 1 ? <span style={{ color: '#999' }}>已取消</span> :
                                                        item.state === 2 ? <span style={{ color: '#FAAD14' }}>待审核</span>
                                                            : item.state === 3 ? <span style={{ color: '#52C41A' }}>已完成</span> : '--'
                                            }
                                            </div>
                                        </List.Item>
                                    )}
                                />
                            </div>
                        ),
                    },
                    {
                        key: '2',
                        label: '我卖出的',
                        children: (
                            <div>
                                <List
                                    pagination={{
                                        position: 'bottom',
                                        align: 'end',
                                        total,
                                        current: queryParams.current,
                                        pageSize: queryParams.pageSize,
                                        showTotal: (total) => `共 ${total} 条`,
                                        onChange: (value) => onPaginationChange(value)
                                    }}
                                    dataSource={dataSource}
                                    renderItem={(item, index) => (
                                        <List.Item
                                            onClick={() => getDetail(item.id)}
                                        >
                                            <List.Item.Meta
                                                // avatar={<Avatar src={`https://api.dicebear.com/7.x/miniavs/svg?seed=${index}`} />}
                                                title={<Space><span>{item.title}</span> -<span>{item.orderCompany}</span></Space>}
                                                description={<Space><span>{item.createDate}</span> <span>{item.remark}</span></Space>}
                                            />
                                            <div>{
                                                item.state === 0 ? <Space><span style={{ color: '#666' }}>待确认</span>
                                                    <Button danger type='link' onClick={onEdit}>取消</Button></Space> :
                                                    item.state === 1 ? <span style={{ color: '#999' }}>已取消</span> :
                                                        item.state === 2 ? <span style={{ color: '#FAAD14' }}>待审核</span>
                                                            : item.state === 3 ? <span>已完成</span> : '--'
                                            }
                                            </div>
                                        </List.Item>
                                    )}
                                />
                            </div>
                        ),
                    },
                ]} />

            <Modal
                title="订单详情"
                open={openModal}
                onCancel={() => {
                    setOpenModal(false);
                    setOrderDetail({})
                }}
                footer={null}
                width={800}
            >
                <Divider />

                <Descriptions
                    column={2}
                    labelStyle={{ width: '80px' }}
                >

                    <Descriptions.Item
                        label='订单号'
                    >
                        {orderDetail.id}
                    </Descriptions.Item>

                    {
                        queryParams.type === 1 ? (
                            <Descriptions.Item
                                label='集团名称'
                                span={2}
                            >
                                {orderDetail.orderUserCompany}
                            </Descriptions.Item>) : (
                            <>
                                <Descriptions.Item
                                    label='集团名称'
                                    span={2}
                                >
                                    {orderDetail.orderCompany}
                                </Descriptions.Item>

                                <Descriptions.Item
                                    label='联系人'
                                >
                                    {orderDetail.contactUser}
                                </Descriptions.Item>

                                <Descriptions.Item
                                    label='联系方式'
                                >
                                    {orderDetail.contactPhone}
                                </Descriptions.Item>
                            </>
                        )
                    }

                    <Descriptions.Item
                        label='服务类型'
                    >
                        <span className='color-primary'>{orderDetail.classifyName}</span>
                    </Descriptions.Item>

                    <Descriptions.Item
                        label='服务内容'
                    >
                        <span className='color-primary'>{orderDetail.content}</span>
                    </Descriptions.Item>

                    <Descriptions.Item
                        label='服务地址'
                    >
                        {orderDetail.address}
                    </Descriptions.Item>

                    <Descriptions.Item
                        label='服务日期'
                    >
                        {orderDetail.startDate + ' ~ ' + orderDetail.endDate}
                    </Descriptions.Item>

                    <Descriptions.Item
                        label='备注'
                        span={2}
                    >
                        {orderDetail.remark}
                    </Descriptions.Item>

                    <Descriptions.Item
                        label='创建时间'
                        span={1}
                    >
                        {orderDetail.createDate}
                    </Descriptions.Item>

                    {
                        orderDetail.contractUrl ? (
                            <Descriptions.Item
                                label='合同'
                                span={1}
                            >
                                <a href={serverUrl + orderDetail.contractUrl} target="_blank" rel="noopener noreferrer" onClick={() => window.open(serverUrl + orderDetail.contractUrl, '_blank')}>
                                    合同预览
                                </a>
                            </Descriptions.Item>
                        ) : null
                    }


                </Descriptions>

                {
                    orderDetail.state === 0 ? (
                        <>
                            <Divider orientation="left">上传合同</Divider>

                            {/* <Upload {...props}>
                                <Button icon={<UploadOutlined />}>点击上传</Button>
                            </Upload> */}

                            <Upload.Dragger {...props}>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">单击或拖动文件到此区域进行上传</p>
                            </Upload.Dragger>
                        </>
                    ) : null
                }
            </Modal>
        </Card>
    )
}
